import { render, staticRenderFns } from "./AddInvoiceProducts.vue?vue&type=template&id=2077edb3&scoped=true"
import script from "./AddInvoiceProducts.vue?vue&type=script&lang=js"
export * from "./AddInvoiceProducts.vue?vue&type=script&lang=js"
import style0 from "./AddInvoiceProducts.vue?vue&type=style&index=0&id=2077edb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2077edb3",
  null
  
)

export default component.exports